// extracted by mini-css-extract-plugin
export default {"listItem":"EmailTemplate_listItem__QzC8O","container":"EmailTemplate_container__mhqty","head":"EmailTemplate_head__XmeBX"};